import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { formatDate, formatNumber, ROUTES } from '../../shared/constants'
import CustomViewForm from '../../components/CustomViewForm'
import { useSalesReturn } from '../../hooks/Sales/useSalesReturn'

export default function ViewSalesReturn() {
  const { salesReturn, loading, getSalesReturn } = useSalesReturn()
  const params = useParams()
  const [data, setData] = useState([])

  useEffect(() => {
    getSalesReturn({ salesReturnId: params.salesReturnId })
  }, [params.salesReturnId])

  useEffect(() => {
    if (salesReturn) {
      setData([
        { label: 'Sales Return Code', data: salesReturn.salesReturnCode },
        { label: 'Sale Invoice Number', data: salesReturn.saleInvoiceNumber },
        { label: 'Sales Return Invoice Number', data: salesReturn.saleInvoiceNumber },
        { label: 'Sales Return Invoice Number', data: formatDate(salesReturn.invoiceDate) },
        { label: 'Quantity', data: salesReturn.quantity },
        { label: 'Billing Price', data: formatNumber(salesReturn.billingPrice) },
        { label: 'Amount', data: formatNumber(salesReturn.amount) },
        { label: 'Products', data: salesReturn.product, type: 'Array', field: 'name', field2: 'sku' },
      ])
    }
  }, [salesReturn])

  return (
    <Layout heading="Sales Return" heading2="Info" url1={ROUTES.SALES_RETURN} none>
      {!loading ? (
        <HeaderTabLayout
          heading="Sales Return"
          content={<CustomViewForm data={data} />}
          view
          // url={`/edit-primary-sales/${params.salesReturnId}`}
        />
      ) : (
        <Loader />
      )}
    </Layout>
  )
}
